module.exports = __webpack_public_path__ + "static/img/码上诉求@4x.3b9dcd3b.png";